{
  "info": "信息",
  "negative": "错误",
  "positive": "成功"
}
